import { useState } from "react";
import cnBind from "classnames/bind";
import { Paginator } from "primereact/paginator";
import type { CreateNewsDto } from "@/entities/types/entities";
import { CardArticle } from "@/view/Articles/components/CardArticle";
import styles from "./Articles.module.scss";
import { FormFeedback } from "@/components/_Forms/FormFeedback";
import Image from "next/image";
import { StaticImport } from "next/dist/shared/lib/get-img-props";

const cx = cnBind.bind(styles);

type Props = {
    listArticles: CreateNewsDto[];
    title: string;
    url: string;
    imgSrc: StaticImport | string;
};

export const Articles = ({
                             listArticles,
                             title,
                             url,
                             imgSrc
                         }: Props) => {
    const [first, setFirst] = useState(0);
    const [rows, setRows] = useState(6);

    const paginated = listArticles.slice(first, first + rows);

    const onPageChange = (event: { first: number; rows: number }) => {
        setFirst(event.first);
        setRows(event.rows);
    };

    return (
        <div className={cx("articles-page")}>
            {/* HERO БЛОК */}
            <div className={cx("main-block")}>
                <Image
                    src={imgSrc}
                    alt={title}
                    priority
                    fill
                    sizes="(max-width: 768px) 100vw, 65vw"
                    className={cx("main-image")}
                />
                <div className={cx("container")}>
                    <div className={cx("hero-content")}>
                        <h1>{title}</h1>
                    </div>
                </div>
            </div>

            {/* СЕТКА СТАТЕЙ */}
            <div className={cx("container")}>
                <div className={cx("articles-section")}>
                    <div className={cx("articles-grid")}>
                        {paginated.map((el) => (
                            <CardArticle
                                url={url}
                                key={el.id || el.urlTitle}
                                item={el}
                            />
                        ))}
                    </div>
                    {listArticles.length > rows && (
                        <Paginator
                            className={cx("paginator")}
                            first={first}
                            rows={rows}
                            totalRecords={listArticles.length}
                            onPageChange={onPageChange}
                        />
                    )}
                </div>
            </div>

            {/* ФОРМА ОБРАТНОЙ СВЯЗИ - без container */}
            <FormFeedback />
        </div>
    );
};